import React, { useEffect, useState } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { getCurriculumState } from '../../../../store/CurriculumSlice';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';
import {
  getDashboardSelectedCurriculumFromLocalStorage,
  setDashboardSelectedCurriculumToLocalStorage,
} from '../../../../helper/LocalStorage';

const selectStyles: SxProps = {
  textAlign: 'center',
  backgroundColor: '#1A1D27',
  color: 'white',
  borderRadius: '26px',
  fontSize: '14px',
  fontWeight: '600',
  '& .MuiSelect-icon': {
    color: 'white',
    fontSize: '1.5rem',
  },
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
};

interface CurriculumSelectorProps {
  handleCurriculumChange: (curriculum: string) => void;
}

const CurriculumSelector: React.FC<CurriculumSelectorProps> = ({
  handleCurriculumChange,
}) => {
  // State
  const [selectedOption, setSelectedOption] = useState('');

  // Store
  const { user: authUser } = useAppSelector(getAuthState);
  const { curriculumsForHomePage: curriculumList } = useAppSelector(
    getCurriculumState
  );

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedOption(event.target.value);
    handleCurriculumChange(event.target.value);

    if (!authUser?.curriculum) {
      setDashboardSelectedCurriculumToLocalStorage(event.target.value);
    }
  };

  useEffect(() => {
    if (!selectedOption && curriculumList.length) {
      let curriculum = curriculumList[0];
      if (authUser?.curriculum) {
        const authUserCurriculum = curriculumList.find(
          (item) => item.nameV2 === authUser.curriculum
        );
        if (authUserCurriculum) {
          curriculum = authUserCurriculum;
        }
      } else {
        const selectedCurriculum = getDashboardSelectedCurriculumFromLocalStorage();

        if (selectedCurriculum) {
          const selectedCurriculumItem = curriculumList.find(
            (item) => item.name === selectedCurriculum
          );
          if (selectedCurriculumItem) {
            curriculum = selectedCurriculumItem;
          }
        }
      }

      if (curriculum && curriculum.name !== selectedOption) {
        setSelectedOption(curriculum.name);
        handleCurriculumChange(curriculum.name);
      }
    }
  }, [curriculumList, authUser]);

  return curriculumList.length ? (
    <FormControl sx={{ minWidth: 213 }}>
      <Select
        value={selectedOption}
        onChange={handleChange}
        displayEmpty
        variant="outlined"
        IconComponent={KeyboardArrowDownIcon}
        sx={selectStyles}
      >
        {curriculumList.map((curriculumItem, index) => (
          <MenuItem key={index} value={curriculumItem.name}>
            {curriculumItem.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : null;
};

export default CurriculumSelector;
